import { render, staticRenderFns } from "./ProductsInvoice.vue?vue&type=template&id=53bdc65f&scoped=true&"
import script from "./ProductsInvoice.vue?vue&type=script&lang=js&"
export * from "./ProductsInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInvoice.vue?vue&type=style&index=0&id=53bdc65f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdc65f",
  null
  
)

export default component.exports